import { FaArrowRightLong } from "react-icons/fa6"
import { Link } from "react-router-dom"

const Contact = () => {
    return (
        <div className="w-full md:w-5/6 lg:w-[27rem] h-fit bg-sky-900 rounded-2xl border py-8 flex flex-col p-8 gap-5" >
            <div className="text-white  text-lg font-semibold">
                <p>Have Questions?</p>
                <p>Contact UNITEN Admission Now</p>
            </div>
            <Link to={"/contact us"} className="flex gap-3 text-center justify-center font-bold items-center p-2 px-8 2xl:text-[16px] 2xl:leading-7 rounded bg-[#9c0000] text-white w-fit text-xs whitespace-nowrap">
                Contact
                <FaArrowRightLong />
            </Link>
        </div>
    )
}

export default Contact